import React from "react";
import { Modal, ModalHeader, ModalBody, Button, Spinner } from "reactstrap";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { investorSchema } from "../../../validations/validation-schemas";
import useAxios from "../../../sections/useAxios";

const InvestorEditForm = ({ isOpen, toggle, investor, refetch }) => {
  const api = useAxios();

  const mutation = useMutation(
    async (values) => {
      return api.patch(`company/update-investor/${investor.id}`, values);
    },
    {
      onSuccess: () => {
        toast.success("Investor updated successfully");
        refetch();
        toggle();
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      name: investor?.name || "",
      email: investor?.email || "",
      company: investor?.company || "",
    },
    enableReinitialize: true,
    validationSchema: investorSchema,
    onSubmit: (values) => mutation.mutate(values),
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Investor</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""
                }`}
              {...formik.getFieldProps("name")}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="invalid-feedback">{formik.errors.name}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""
                }`}
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="invalid-feedback">{formik.errors.email}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Company</label>
            <input
              type="text"
              className={`form-control ${formik.touched.company && formik.errors.company ? "is-invalid" : ""
                }`}
              {...formik.getFieldProps("company")}
            />
            {formik.touched.company && formik.errors.company && (
              <div className="invalid-feedback">{formik.errors.company}</div>
            )}
          </div>

          <div className="text-start">
            <Button type="submit" className="primary-bg text-white primary-hover" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner size="sm" /> : "Save Changes"}
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default InvestorEditForm;
